import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.string.link.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import { Button, Icon, InputAdornment, RaiseColors, ShadowContainer, Typography, makeStyles, useTheme, useMediaQuery } from "componentLibrary";
import TextLink from "componentLibrary/TextLink/TextLink";
import TextField from "components/mui/Fields/Fields/TextField/TextField";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import { Form, Formik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      container: _defineProperty({
        display: "flex",
        flexDirection: "column",
        padding: 32,
        width: 495
      }, theme.breakpoints.down("smMd"), {
        width: 360,
        padding: 16
      }),
      containerDiv: {
        display: "flex",
        flexDirection: "row"
      },
      containerHeaderText: {
        marginBottom: 8
      },
      containerIcon: {
        display: "flex",
        width: "40px",
        height: "40px",
        padding: "8px 16px",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        borderRadius: "200px",
        border: "1px solid var(--neutral-neutral-300, #E8E7EB)",
        background: "var(--neutral-neutral-100, #FFF)",
        boxShadow: " 0px 0px 8px 0px rgba(73, 0, 227, 0.08)",
        cursor: "pointer"
      },
      containerIconText: {
        marginBottom: "32px",
        display: "flex",
        flexDirection: "column"
      },
      errorDiv: {
        backgroundColor: RaiseColors.destructive300,
        padding: "12px 20px",
        border: "1px solid ".concat(RaiseColors.destructive300),
        borderRadius: "6px",
        marginBottom: "24px",
        display: "flex"
      },
      textField: {
        backgroundColor: RaiseColors.neutral100,
        boxShadow: "0px 0px 14px 0px ".concat(RaiseColors.midnight, "14"),
        color: RaiseColors.gray100,
        "&:hover": {
          borderColor: RaiseColors.midnight
        }
      },
      adornment: {
        marginLeft: 8,
        marginTop: 4,
        marginBottom: 4,
        marginRight: 0
      },
      formikContainer: {
        marginBottom: 24
      },
      formikLabel: {
        marginBottom: 8
      },
      formikButton: {
        borderRadius: 200,
        height: 48
      },
      termsDiv: _defineProperty({
        display: "flex",
        alignItems: "center",
        gap: 24,
        marginTop: 32
      }, theme.breakpoints.down("smMd"), {
        marginTop: 16
      }),
      link: {
        textDecoration: "none",
        marginTop: 32,
        paddingBottom: 8
      },
      linkText: {
        textDecoration: "none"
      }
    };
  });
};
var LoginFormContentContainer = function LoginFormContentContainer(_ref) {
  var header = _ref.header,
    subHeader = _ref.subHeader,
    formElements = _ref.formElements,
    ValidationSchema = _ref.ValidationSchema,
    handleSubmit = _ref.handleSubmit,
    loading = _ref.loading,
    isError = _ref.isError,
    errorMessage = _ref.errorMessage,
    buttonText = _ref.buttonText,
    additionalFormLinks = _ref.additionalFormLinks;
  var classes = useStyles()();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("md"));
  var checkForEnter = function checkForEnter(_ref2) {
    var event = _ref2.event,
      submitForm = _ref2.submitForm;
    if (event.keyCode === 13) {
      submitForm();
    }
  };
  var initialValues = _reduceInstanceProperty(formElements).call(formElements, function (obj, element) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, element.id, element.initialValue));
  }, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Formik, {
      validationSchema: ValidationSchema,
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validateOnChange: false,
      children: function children(formikUtils) {
        var handleChange = formikUtils.handleChange,
          submitForm = formikUtils.submitForm,
          formErrors = formikUtils.errors;
        var errorCheck = _Object$keys(formErrors).length !== 0 || isError;
        return /*#__PURE__*/_jsx(Form, {
          onKeyDown: function onKeyDown(event) {
            checkForEnter({
              event: event,
              submitForm: submitForm
            });
          },
          children: /*#__PURE__*/_jsx(ShadowContainer, {
            children: /*#__PURE__*/_jsxs("div", {
              className: classes.container,
              children: [/*#__PURE__*/_jsx("div", {
                className: classes.containerDiv,
                children: /*#__PURE__*/_jsxs("div", {
                  className: classes.containerIconText,
                  children: [/*#__PURE__*/_jsx(Typography, {
                    variant: "h3",
                    weight: "semibold",
                    className: classes.containerHeaderText,
                    color: RaiseColors.jllNeutral100,
                    children: header || "Sign in"
                  }), subHeader ? /*#__PURE__*/_jsx(Typography, {
                    variant: "paragraph_medium",
                    children: subHeader
                  }) : null]
                })
              }), errorCheck && /*#__PURE__*/_jsxs("div", {
                className: classes.errorDiv,
                children: [/*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx(Icon, {
                    className: "fa-light fa-exclamation-triangle",
                    color: RaiseColors.destructive700,
                    style: {
                      paddingRight: "8px"
                    }
                  })
                }), /*#__PURE__*/_jsx("div", {
                  children: /*#__PURE__*/_jsx(Typography, {
                    color: RaiseColors.destructive700,
                    weight: "semibold",
                    variant: "paragraph_medium",
                    style: {
                      whiteSpace: "normal"
                    },
                    children: errorMessage
                  })
                })]
              }), _mapInstanceProperty(formElements).call(formElements, function (element) {
                return /*#__PURE__*/_jsxs("div", {
                  className: classes.formikContainer,
                  children: [/*#__PURE__*/_jsx(Typography, {
                    variant: "paragraph_small",
                    weight: "medium",
                    color: RaiseColors.midnight,
                    className: classes.formikLabel,
                    children: element.label
                  }), /*#__PURE__*/_jsx(ShadowContainer, {
                    children: /*#__PURE__*/_jsx(MuiFormikField, {
                      Component: TextField,
                      fullWidth: true,
                      name: element.id,
                      id: element.id,
                      placeholder: element.placeholder,
                      className: classes.textField,
                      variant: "outlined",
                      size: "large",
                      InputProps: {
                        style: {
                          height: 48
                        },
                        startAdornment: /*#__PURE__*/_jsx(InputAdornment, {
                          position: "start",
                          className: classes.adornment,
                          children: /*#__PURE__*/_jsx(Icon, {
                            className: element.type === "password" ? "fa-thin fa-lock" : "fal fa-envelope",
                            fontSize: "small"
                          })
                        })
                      },
                      onChange: function onChange(e) {
                        if (!element.type) {
                          var _context;
                          e.target.value = _trimInstanceProperty(_context = e.target.value).call(_context);
                        }
                        handleChange(e);
                      },
                      type: element.type
                    })
                  })]
                }, element.id);
              }), /*#__PURE__*/_jsx(Button, {
                variant: "newPrimary",
                onClick: function onClick() {
                  submitForm();
                },
                className: classes.formikButton,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph_large",
                  weight: "medium",
                  color: RaiseColors.neutral100,
                  children: loading ? /*#__PURE__*/_jsx(Icon, {
                    className: "fa fa-pulse fa-spinner"
                  }) : buttonText
                })
              }), additionalFormLinks && _mapInstanceProperty(additionalFormLinks).call(additionalFormLinks, function (link) {
                return /*#__PURE__*/_jsx("div", {
                  className: classes.link,
                  children: /*#__PURE__*/_jsx(Link, {
                    to: link.to,
                    className: classes.linkText,
                    children: /*#__PURE__*/_jsx(TextLink, {
                      children: link.label
                    })
                  }, link.id)
                });
              })]
            })
          })
        });
      }
    }), /*#__PURE__*/_jsxs("div", {
      className: classes.termsDiv,
      children: [/*#__PURE__*/_jsx("a", {
        href: "https://www.jllt.com/legal-agreements/jllt/terms-of-service/",
        target: "_blank",
        rel: "noopener noreferrer",
        className: classes.linkText,
        children: /*#__PURE__*/_jsx(TextLink, {
          children: "Terms of Service"
        })
      }), /*#__PURE__*/_jsx("a", {
        href: "https://www.us.jll.com/en/privacy-statement",
        target: "_blank",
        rel: "noopener noreferrer",
        className: classes.linkText,
        children: /*#__PURE__*/_jsx(TextLink, {
          children: "Privacy Policy"
        })
      })]
    })]
  });
};
export default LoginFormContentContainer;